"use client";

import { PAGE_BG_STYLE } from "@/lib/pageBg";
import { useState, useEffect } from "react";
import AppHeader from "@/components/AppHeader";
import Footer from "@/components/Footer";
import { ExternalLink, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

const EMON_URL = "https://emonboost.com/emon";

export default function Emon(): JSX.Element {
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [iframeFailed, setIframeFailed] = useState(false);

  useEffect(() => {
    // Timeout fallback - if iframe doesn't load in 5 seconds, show button
    const timeout = setTimeout(() => {
      if (!iframeLoaded) {
        setIframeFailed(true);
      }
    }, 5000);

    return () => clearTimeout(timeout);
  }, [iframeLoaded]);

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <AppHeader currentPage="emon" />

      <main className="flex-1 pt-16">
        {!iframeFailed ? (
          <div className="relative w-full h-[calc(100vh-4rem-3rem)]">
            {!iframeLoaded && (
              <div className="absolute inset-0 flex items-center justify-center bg-background">
                <Loader2 className="h-8 w-8 animate-spin text-primary" />
              </div>
            )}
            <iframe
              src={EMON_URL}
              className="w-full h-full border-0"
              title="EMON Token"
              onLoad={() => setIframeLoaded(true)}
              onError={() => setIframeFailed(true)}
              sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
            />
          </div>
        ) : (
          <div className="flex-1 flex items-center justify-center px-4 py-20">
            <div className="max-w-md w-full text-center space-y-6">
              <h1 className="text-2xl font-semibold text-foreground">EMON Token</h1>
              <p className="text-muted-foreground">
                This page cannot be embedded due to security restrictions. 
                Open it directly to view the full content.
              </p>
              <Button asChild size="lg" className="w-full">
                <a href={EMON_URL} target="_blank" rel="noopener noreferrer">
                  <ExternalLink className="mr-2 h-4 w-4" />
                  Open EMON Page
                </a>
              </Button>
            </div>
          </div>
        )}
      </main>

      <Footer />
    </div>
  );
}
